export const UNIT_TRANSLATIONS = {
  count: "عدد",
  package: "بسته",
  weight: "کیلوگرم",
  length: "متر",
  area: "متر مربع",
  litr: "لیتر",
  volume: "متر مکعب",
};